import { useMemo } from "react";
import { IPlannerEventUserModel } from "../models/plannerEventUserModel";

/**
 * Derives the one-line note preview shown at the bottom of a reservation row.
 *
 * The backend already hands the notes over newest first
 * (PlannerService: .OrderByDescending(n => n.CreatedOn)), so the preview is
 * simply the first note that actually carries text. Blank notes are skipped
 * rather than shown, so an empty newest note never hides a real older one.
 *
 * The full content is returned untouched apart from whitespace collapsing -
 * the visual cut-off is left to CSS (text-overflow: ellipsis), which cuts at
 * the real width of the row instead of an invented character count.
 */
export const usePlannerEventUserItemNote = (user?: IPlannerEventUserModel) =>
  useMemo(() => {
    const notesWithContent = (user?.notes ?? [])
      .map((note) => note.content?.replace(/\s+/g, " ").trim() ?? "")
      .filter((content) => content.length > 0);

    return {
      notePreview: notesWithContent[0] ?? "",
      extraNotesCount: Math.max(notesWithContent.length - 1, 0),
    };
  }, [user?.notes]);
